import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { DefaultHeader as Header } from 'enlm_ui_common';
import { forwardTo } from '../../../utils/helper';
import { isEmpty, get } from '../../../utils/lodash';
import { setSolargrafAccess } from '../../../containers/Preferences/actions';

const DefaultHeader = props => {
  const search = get(props, 'location.search', '');
  const { token } = queryString.parse(search);
  if (!isEmpty(token)) {
    return null;
  }
  //for self installers, appReducer.country will be null. Hence, user's country is accessed from accountReducer
  const { country, user_country } = props;
  const country_value = country ? country : user_country
  return <Header {...props} country={country_value} forwardTo={forwardTo} />;
};

const mapStateToProps = state => ({
  companyState: state.appReducer.companyState,
  einOptIn: state.appReducer.einOptIn,
  einOptOut: state.appReducer.einOptOut,
  country: state.appReducer.countryCode,
  company: state.appReducer.company,
  companyInfo: state.appReducer.companyInfo,
  dashboardLinks: state.appReducer.dashboardLinks,
  featureList: state.appReducer.featureList,
  enlightenManagerToken: state.appReducer.enlightenManagerToken,
  accountDetail: state.accountReducer.accountDetail,
  user_country: state.accountReducer.accountDetail.country,
  viewOnlyAccess: state.accountReducer.viewOnlyAccess,
  viewCannotEdit: state.accountReducer.viewCannotEdit,
  locale: state.accountReducer.locale,
  preferencesData: state.preferencesReducer.preferencesData,
  solargrafAccess: state.preferencesReducer.solargrafAccess,
  trainingDashboardToken: state.accountReducer.trainingDashboardToken
});

const mapDispatchToProps = dispatch => ({
  setSolargrafAccess: payload => dispatch(setSolargrafAccess(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeader);
